export const passwordPhrase =
  "A password must be at least 8 characters, and requires one uppercase letter, one lowercase letter, and one number"
